module.exports = __webpack_public_path__ + "img/icon-expense-2.3c87584e.svg";